import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface Notification {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notification[]>([]);

  const addNotification = (notification: Omit<Notification, 'id'>) => {
    const id = Math.random().toString(36).substring(2);
    const newNotification = {
      id,
      duration: 3000, // Default duration
      ...notification
    };
    
    notifications.value.push(newNotification);

    if (newNotification.duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, newNotification.duration);
    }
  };

  const removeNotification = (id: string) => {
    notifications.value = notifications.value.filter(n => n.id !== id);
  };

  const success = (message: string, duration = 3000) => {
    addNotification({ message, type: 'success', duration });
  };

  const error = (message: string, duration = 3000) => {
    addNotification({ message, type: 'error', duration });
  };

  const info = (message: string, duration = 3000) => {
    addNotification({ message, type: 'info', duration });
  };

  const warning = (message: string, duration = 3000) => {
    addNotification({ message, type: 'warning', duration });
  };

  return {
    notifications,
    addNotification,
    removeNotification,
    success,
    error,
    info,
    warning
  };
});